export default "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" width=\"100%\" height=\"100%\">\n  <path d=\"M6 6h12v12H6z\" />\n</svg>"